let Main = () => import('../components/Main.vue');
let Login = () => import('../components/pages/Login.vue');
let Home = () => import('../components/pages/Home.vue');
let BarcodeLogin = () => import('../components/pages/BarcodeLogin.vue');
let Error404 = () => import('../components/pages/errors/Error404.vue');

// user
let Management = () => import('../components/pages/Management.vue');
let User = () => import('../components/pages/users/Index.vue');
let TableUser = () => import('../components/pages/users/Table.vue');

// permission
let Permission = () => import('../components/pages/permissions/Index.vue');
let TablePermission = () => import('../components/pages/permissions/Table.vue');

// role
let Role = () => import('../components/pages/roles/Index.vue');
let TableRole = () => import('../components/pages/roles/Table.vue');

// activity logs
let ActivityLogs = () => import('../components/pages/activity_logs/Index.vue');
let TableActivityLogs = () => import('../components/pages/activity_logs/Table.vue');

// Hauler
let Hauler = () => import('../components/pages/hauler/Index.vue');
let EnrolHauler = () => import('../components/pages/hauler/EnrolHauler.vue');
let TableHauler = () => import('../components/pages/hauler/TableHauler.vue');

// Mother ATW
let MotherATW = () => import('../components/pages/mother_atw/Index.vue');
let CreateMotherATW = () => import('../components/pages/mother_atw/CreateMotherATW.vue');
let DeleteMotherATW = () => import('../components/pages/mother_atw/TableMotherATW.vue');

// Individual ATW
let IndividualATW = () => import('../components/pages/individual_atw/Index.vue');
let CreateIndividualATW = () => import('../components/pages/individual_atw/CreateIndividualATW.vue');
let TableIndividualATW = () => import('../components/pages/individual_atw/TableIndividualATW.vue');
let DailyIndividualATW = () => import('../components/pages/individual_atw/DailyIndividualATW.vue');

//Notice
let Notice = () => import('../components/pages/notice/Index.vue');
let Announcement = () => import('../components/pages/notice/Announcement.vue');
let Millsite = () => import('../components/pages/notice/Millsite.vue');
let OTReversal = () => import('../components/pages/notice/OtReversal.vue');

//Withdrawal
let Withdrawal = () => import('../components/pages/withdrawal/WithdrawalIndex.vue');
let WithdrawalBags = () => import('../components/pages/withdrawal/WithdrawalBags.vue');
let WithdrawalBulk = () => import('../components/pages/withdrawal/WithdrawalBulk.vue');
let WithdrawalBagsV2 = () => import('../components/pages/withdrawal_v2/WithdrawalBagsV2.vue');
let WithdrawalBulkV2 = () => import('../components/pages/withdrawal_v2/WithdrawalBulkV2.vue');
let WithdrawalMolasses = () => import('../components/pages/withdrawal_v2/Molasses.vue');

//Status
let Status = () => import('../components/pages/status/AtwStatus.vue');

//Report
let Report = () => import('../components/pages/reports/Index.vue');
let ReportDO = () => import('../components/pages/reports/DoReport.vue');
let ReportMATW = () => import('../components/pages/reports/MatwReport.vue');
let ReportIATW = () => import('../components/pages/reports/IatwReport.vue');
let ReportDailyWithdrawalWarehouse = () => import('../components/pages/reports/DailyWithdrawalWarehouse.vue');
let ReportDailyWithdrawalSummary = () => import('../components/pages/reports/DailyWithdrawalSummary.vue');

//OR_Payment
let Payments = () => import('../components/pages/payments/Index.vue');
let ORPayment = () => import('../components/pages/payments/OrPayment.vue');
let InsurancePayment = () => import('../components/pages/payments/InsurancePayment.vue');
let StoragePayment = () => import('../components/pages/payments/StoragePayment.vue');
let AreaRefund = () => import('../components/pages/payments/AreaRefund.vue');

//Deletion Request
let DeletionRequest = () => import('../components/pages/deletion_request/DeletionRequest.vue');

//Cancellation Approval
let DRApproval = () => import('../components/pages/deletion_request/DrApproval.vue');

//DR Printing
let DRPrinting = () => import('../components/pages/printing/DeliveryReceiptPrinting.vue');

//Fee
let Fee = () => import('../components/pages/fee/Index.vue');
let FeeTotalCharges = () => import('../components/pages/fee/TotalCharges.vue');
let FeeDOCharges = () => import('../components/pages/fee/DoCharges.vue');

//Maintenance ---------------------------
let Maintenance = () => import('../components/pages/maintenance/Index.vue');
let MaintenanceATWPersonnel = () => import('../components/pages/maintenance/AtwPersonnel.vue');
let MaintenanceDispatcher = () => import('../components/pages/maintenance/Dispatcher.vue');
let MaintenanceLocation = () => import('../components/pages/maintenance/Location.vue');
let MaintenanceBanned = () => import('../components/pages/maintenance/Banned.vue');
let MaintenanceDriver = () => import('../components/pages/maintenance/Driver.vue');
let MaintenanceFeeRates = () => import('../components/pages/maintenance/FeeRates.vue');
let MaintenancePreviousFraction = () => import('../components/pages/maintenance/PreviousFraction.vue');

//Bagging
let Bagging = () => import('../components/pages/bagging/Index.vue');
let BaggingRawSugarTicket = () => import('../components/pages/bagging/RawSugarTicket.vue');
let BaggingRawSugarReport = () => import('../components/pages/bagging/RawSugarReport.vue');

//Trucking
let Trucking = () => import('../components/pages/trucking/Index.vue');
let TruckingDaily = () => import('../components/pages/trucking/Trucking.vue');

//Quedan
let Quedan = () => import('../components/pages/quedan/Index.vue');
let QuedanTolling = () => import('../components/pages/quedan/Tolling.vue');
let QuedanRawSugar = () => import('../components/pages/quedan/RawSugar.vue');
let QuedanTollingTable = () => import('../components/pages/quedan/TollingTable.vue');
let QuedanRawSugarTable = () => import('../components/pages/quedan/RawSugarTable.vue');
let QuedanTransfer = () => import('../components/pages/quedan/TransferQuedan.vue');
let QuedanRedeem = () => import('../components/pages/quedan/redeem/RedeemQuedan.vue');
let QuedanPayable = () => import('../components/pages/quedan/payable/PayableQuedan.vue');
let QuedanTable = () => import('../components/pages/quedan/TableQuedan.vue');

const routes = [
    {
        path: '/login',
        name: "login",
        component: Login,
        meta: {
            title: 'Login',
            requiresAuth: false
        },
    },
    {
        path: '/barcode_login',
        name: "barcode_login",
        component: BarcodeLogin,
        meta: {
            title: 'Barcode Login',
            requiresAuth: false
        },
    },
    {
        path: '*',
        name: 'error404',
        component: Error404,
        meta: {
            title: 'Error 404',
            requiresAuth: false,
        },
    },
    {
        path: "",
        redirect: {name: 'home'},
        component: Main,
        children: [
            {
                path: '/home',
                name: 'home',
                component: Home,
                meta: {
                    title: 'Home',
                    requiresAuth: true,
                }
            },
            {
                path: "/management",
                name: 'management',
                component: Management,
                children: [
                    {
                        path: "/management/users",
                        name: 'users',
                        redirect: {name: 'userTable'},
                        component: User,
                        children: [
                            {
                                path: '/',
                                name: 'userTable',
                                component: TableUser,
                                meta: {
                                    title: 'Users',
                                    requiresAuth: true,
                                }
                            }
                        ]
                    },
                    {
                        path: '/management/permissions',
                        name: 'permissions',
                        redirect: {name: 'permissionTable'},
                        component: Permission,
                        children: [
                            {
                                path: '',
                                name: 'permissionTable',
                                component: TablePermission,
                                meta: {
                                    title: 'Permissions',
                                    requiresAuth: true,
                                }
                            }
                        ]
                    },
                    {
                        path: '/management/roles',
                        name: 'roles',
                        redirect: {name: 'roleTable'},
                        component: Role,
                        children: [
                            {
                                path: '',
                                name: 'roleTable',
                                component: TableRole,
                                meta: {
                                    title: 'Roles',
                                    requiresAuth: true
                                }
                            }
                        ]
                    },
                ]
            },
            {
                path: '/activity-logs',
                name: 'activityLogs',
                redirect: {name: 'activityLogsTable'},
                component: ActivityLogs,
                children: [
                    {
                        path: '/',
                        name: 'activityLogsTable',
                        component: TableActivityLogs,
                        meta: {
                            title: 'Activity Logs',
                            requiresAuth: true
                        }
                    }
                ]
            },
            {
                path: '/hauler',
                name: 'hauler',
                component: Hauler,
                redirect: {name: 'enrol_hauler'},
                children: [
                    {
                        path: "/hauler/enrol_hauler",
                        name: 'enrol_hauler',
                        component: EnrolHauler,
                        meta: {
                            title: 'Enrol Hauler',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: '/hauler/table_hauler',
                        name: 'table_hauler',
                        component: TableHauler,
                        meta: {
                            title: 'Hauler Table',
                            requiresAuth: true,
                        }
                    },
                ]
            },
            {
                path: '/mother_atw',
                name: 'mother_atw',
                component: MotherATW,
                redirect: {name: 'create_mother_atw'},
                children: [
                    {
                        path: "/mother_atw/create_mother_atw",
                        name: 'create_mother_atw',
                        component: CreateMotherATW,
                        meta: {
                            title: 'Create Mother ATW',
                            requiresAuth: true,
                            permissions: 'create_mother_atw',
                            redirectNonAuth: '/mother_atw/delete_mother_atw'
                        }
                    },
                    {
                        path: '/mother_atw/delete_mother_atw',
                        name: 'delete_mother_atw',
                        component: DeleteMotherATW,
                        meta: {
                            title: 'Delete Mother ATW',
                            requiresAuth: true,
                        }
                    },
                ]
            },
            {
                path: '/individual_atw',
                name: 'individual_atw',
                component: IndividualATW,
                redirect: {name: 'create_individual_atw'},
                children: [
                    {
                        path: "/individual_atw/create_individual_atw",
                        name: 'create_individual_atw',
                        component: CreateIndividualATW,
                        meta: {
                            title: 'Create Individual ATW',
                            requiresAuth: true,
                            permissions: 'create_individual_atw',
                            redirectNonAuth: '/individual_atw/table_individual_atw'
                        }
                    },
                    {
                        path: '/individual_atw/table_individual_atw',
                        name: 'table_individual_atw',
                        component: TableIndividualATW,
                        meta: {
                            title: 'Table Individual ATW',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: '/individual_atw/daily_iatw',
                        name: 'daily_iatw',
                        component: DailyIndividualATW,
                        meta: {
                            title: 'Daily Individual ATW',
                            requiresAuth: true,
                        }
                    },
                ]
            },
            {
                path: '/notice',
                name: 'notice',
                component: Notice,
                redirect: {name: 'announcement'},
                children: [
                    {
                        path: "/notice/announcement",
                        name: 'announcement',
                        component: Announcement,
                        meta: {
                            title: 'Announcement',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: '/notice/mill_site',
                        name: 'mill_site',
                        component: Millsite,
                        meta: {
                            title: 'Millsite',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: '/notice/ot_reversal',
                        name: 'ot_reversal',
                        component: OTReversal,
                        meta: {
                            title: 'OT Reversal',
                            requiresAuth: true,
                        }
                    },
                ]
            },
            {
                path: '/withdrawal',
                name: 'withdrawal',
                component: Withdrawal,
                redirect: {name: 'withdrawal_bags_v2'},
                children: [
                    {
                        path: "/withdrawal/bags",
                        name: 'withdrawal_bags',
                        component: WithdrawalBags,
                        meta: {
                            title: 'Withdrawal Bags',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/withdrawal/bulk",
                        name: 'withdrawal_bulk',
                        component: WithdrawalBulk,
                        meta: {
                            title: 'Withdrawal Bulk',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/withdrawal/bags_v2",
                        name: 'withdrawal_bags_v2',
                        component: WithdrawalBagsV2,
                        meta: {
                            title: 'Withdrawal Bags',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/withdrawal/bulk_v2",
                        name: 'withdrawal_bulk_v2',
                        component: WithdrawalBulkV2,
                        meta: {
                            title: 'Withdrawal Bulk',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/withdrawal/molasses",
                        name: 'withdrawal_molasses',
                        component: WithdrawalMolasses,
                        meta: {
                            title: 'Withdrawal Molasses',
                            requiresAuth: true,
                        }
                    },
                ]
            },
            {
                path: '/status',
                name: 'status',
                component: Status,
                meta: {
                    title: 'AtwStatus.vue',
                    requiresAuth: true,
                }
            },
            {
                path: '/report',
                name: 'report',
                component: Report,
                redirect: {name: 'do_report'},
                children: [
                    {
                        path: "/report/do_report",
                        name: 'do_report',
                        component: ReportDO,
                        meta: {
                            title: 'DO Report',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/report/matw_report",
                        name: 'matw_report',
                        component: ReportMATW,
                        meta: {
                            title: 'Mother ATW Report',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/report/iatw_report",
                        name: 'iatw_report',
                        component: ReportIATW,
                        meta: {
                            title: 'Individual ATW Report',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/report/daily_withdrawal_warehouse",
                        name: 'daily_withdrawal_warehouse',
                        component: ReportDailyWithdrawalWarehouse,
                        meta: {
                            title: 'Daily Withdrawal Warehouse Report',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/report/daily_withdrawal_summary",
                        name: 'daily_withdrawal_summary',
                        component: ReportDailyWithdrawalSummary,
                        meta: {
                            title: 'Daily Withdrawal Summary Report',
                            requiresAuth: true,
                        }
                    },
                ]
            },
            {
                path: '/payments',
                name: 'payments',
                component: Payments,
                redirect: {name: 'or_payment'},
                children: [
                    {
                        path: "/payments/or_payment",
                        name: 'or_payment',
                        component: ORPayment,
                        meta: {
                            title: 'OR Payment',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/payments/insurance_payment",
                        name: 'insurance_payment',
                        component: InsurancePayment,
                        meta: {
                            title: 'Insurance Payment',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/payments/storage_payment",
                        name: 'storage_payment',
                        component: StoragePayment,
                        meta: {
                            title: 'Storage Payment',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/payments/area_refund",
                        name: 'area_refund',
                        component: AreaRefund,
                        meta: {
                            title: 'Area Refund',
                            requiresAuth: true,
                        }
                    },
                ],
            },
            {
                path: '/quedan',
                name: 'quedan',
                component: Quedan,
                redirect: {name: 'quedan_table'},
                children: [
                    {
                        path: "/quedan/quedan_table",
                        name: 'quedan_table',
                        component: QuedanTable,
                        meta: {
                            title: 'Quedan Table',
                            requiresAuth: true,
                            permissions: 'view_quedan_transfer',
                            redirectNonAuth: '/quedan/quedan_redeem'
                        }
                    },
                    {
                        path: "/quedan/quedan_transfer",
                        name: 'quedan_transfer',
                        component: QuedanTransfer,
                        meta: {
                            title: 'Quedan Transfer',
                            requiresAuth: true,
                            permissions: 'view_quedan_transfer',
                            redirectNonAuth: '/quedan/quedan_redeem'
                        }
                    },
                    {
                        path: "/quedan/quedan_redeem",
                        name: 'quedan_redeem',
                        component: QuedanRedeem,
                        meta: {
                            title: 'Quedan Redeem',
                            requiresAuth: true,
                            permissions: 'view_quedan_redeem',
                            redirectNonAuth: '/quedan/quedan_payable'
                        }
                    },
                    {
                        path: "/quedan/quedan_payable",
                        name: 'quedan_payable',
                        component: QuedanPayable,
                        meta: {
                            title: 'Quedan Payable',
                            permissions: 'view_quedan_payable',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/quedan/quedan_tolling/:id",
                        name: 'quedan_tolling',
                        component: QuedanTolling,
                        meta: {
                            title: 'Surrender Quedan(Tolling)',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/quedan/quedan_raw_sugar/:id",
                        name: 'quedan_raw_sugar',
                        component: QuedanRawSugar,
                        meta: {
                            title: 'Surrender Quedan(Raw Sugar)',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/quedan/tolling_logs",
                        name: 'tolling_logs',
                        component: QuedanTollingTable,
                        meta: {
                            title: 'Surrender Quedan(Tolling) Transaction Logs',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/quedan/raw_sugar_logs",
                        name: 'raw_sugar_logs',
                        component: QuedanRawSugarTable,
                        meta: {
                            title: 'Surrender Quedan(Raw Sugar) Transaction Logs',
                            requiresAuth: true,
                        }
                    },
                ],
            },
            {
                path: '/deletion_request',
                name: 'deletion_request',
                component: DeletionRequest,
                meta: {
                    title: 'Deletion-Request',
                    requiresAuth: true,
                }
            },
            {
                path: '/dr_approval',
                name: 'dr_approval',
                component: DRApproval,
                meta: {
                    title: 'DR-Approval',
                    requiresAuth: true,
                }
            },
            {
                path: '/dr_printing',
                name: 'dr_printing',
                component: DRPrinting,
                meta: {
                    title: 'DR-Printing',
                    requiresAuth: true,
                }
            },
            {
                path: '/maintenance',
                name: 'maintenance',
                component: Maintenance,
                redirect: {name: 'driver'},
                children: [
                    {
                        path: "/maintenance/m_atw_personnel",
                        name: 'm_atw_personnel',
                        component: MaintenanceATWPersonnel,
                        meta: {
                            title: 'ATW Personnel',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/maintenance/dispatcher",
                        name: 'dispatcher',
                        component: MaintenanceDispatcher,
                        meta: {
                            title: 'Dispatcher',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/maintenance/location",
                        name: 'location',
                        component: MaintenanceLocation,
                        meta: {
                            title: 'Location',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/maintenance/banned",
                        name: 'banned',
                        component: MaintenanceBanned,
                        meta: {
                            title: 'Banned Personnel',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/maintenance/driver",
                        name: 'driver',
                        component: MaintenanceDriver,
                        meta: {
                            title: 'Driver',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/maintenance/fee_rates",
                        name: 'fee_rates',
                        component: MaintenanceFeeRates,
                        meta: {
                            title: 'Fee Rates',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/maintenance/previous_fraction",
                        name: 'previous_fraction',
                        component: MaintenancePreviousFraction,
                        meta: {
                            title: 'Previous Fraction',
                            requiresAuth: true,
                        }
                    },
                ]
            },
            {
                path: '/bagging',
                name: 'bagging',
                component: Bagging,
                redirect: {name: 'rsb_ticket'},
                children: [
                    {
                        path: "/bagging/rsb_ticket",
                        name: 'rsb_ticket',
                        component: BaggingRawSugarTicket,
                        meta: {
                            title: 'Raw Sugar Bagging Ticket',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/bagging/rsb_report",
                        name: 'rsb_report',
                        component: BaggingRawSugarReport,
                        meta: {
                            title: 'Raw Sugar Bagging Report',
                            requiresAuth: true,
                        }
                    },
                ]
            },
            {
                path: '/trucking',
                name: 'trucking',
                component: Trucking,
                redirect: {name: 'trucking_daily'},
                children: [
                    {
                        path: "/trucking/trucking_daily",
                        name: 'trucking_daily',
                        component: TruckingDaily,
                        meta: {
                            title: 'Trucking :Daily',
                            requiresAuth: true,
                        }
                    },
                ]
            },
            {
                path: '/fee',
                name: 'fee',
                component: Fee,
                redirect: {name: 'total_charges'},
                children: [
                    {
                        path: "/fee/total_charges",
                        name: 'total_charges',
                        component: FeeTotalCharges,
                        meta: {
                            title: 'Total Charges',
                            requiresAuth: true,
                        }
                    },
                    {
                        path: "/fee/do_charges",
                        name: 'do_charges',
                        component: FeeDOCharges,
                        meta: {
                            title: 'DO Charges',
                            requiresAuth: true,
                        }
                    },
                ]
            },
        ],
    }
];

export default routes;
